import './store';
import './component-renderer';

import './module-lazy-loader';